import { render, staticRenderFns } from "./budget-forms-template4.vue?vue&type=template&id=221a17d6&scoped=true&"
import script from "./budget-forms-template4.vue?vue&type=script&lang=js&"
export * from "./budget-forms-template4.vue?vue&type=script&lang=js&"
import style0 from "./budget-forms-template4.vue?vue&type=style&index=0&id=221a17d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a17d6",
  null
  
)

export default component.exports